import { useMemo } from 'react';
import { useI18n } from '@/i18n';
import { Calendar } from '@/components/ui/calendar';
import { es } from 'date-fns/locale';

export function CalendarSection({ selectedDates, onSelectDates, blockedDates, isDateBlocked }) {
  const { t } = useI18n();

  const blockedModifiers = useMemo(() => ({ blocked: (date) => isDateBlocked(date) }), [isDateBlocked]);
  const blockedStyles = useMemo(() => ({ blocked: { textDecoration: 'line-through', opacity: 0.4, color: '#C36F4D' } }), []);

  return (
    <div className="mb-6">
      <label className="block text-sm font-medium text-[#1C1917] mb-2">
        {t('detail.selectDates')}
      </label>
      <div className="border border-[#E7E5E4] rounded-lg p-2">
        <Calendar
          mode="range"
          selected={selectedDates}
          onSelect={onSelectDates}
          numberOfMonths={1}
          locale={es}
          className="rounded-md"
          disabled={(date) => date < new Date() || isDateBlocked(date)}
          modifiers={blockedModifiers}
          modifiersStyles={blockedStyles}
          data-testid="booking-calendar"
        />
      </div>
      {blockedDates.length > 0 && (
        <div className="flex items-center gap-4 mt-2 px-2 text-xs text-[#78716C]">
          <span className="flex items-center gap-1">
            <span className="w-3 h-3 rounded bg-[#C36F4D]/20 inline-block"></span> {t('detail.notAvailable')}
          </span>
          <span>{blockedDates.filter(b => b.source === 'airbnb').length > 0 ? t('detail.includesAirbnb') : ''}</span>
        </div>
      )}
    </div>
  );
}
